import React, { Component } from "react";
import Logo from "../assets/logo-w.svg";
import BgImage from "../assets/login-image.png";
import { observer } from "mobx-react";
import loginStore from "../stores/loginStore";
import { Bars } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

function withRouter(Component) {
  return function WrapperComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

const Login = observer(
  class Login extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: false,
      };
    }

    async componentDidMount() {
      loginStore.loginHandleRedirectPromise();
    }

    render() {
      const { loading } = this.state;
      return (
        <div className="flex flex-col flex-1 h-screen sm:flex-row gap-20 lg:gap-0">
          <div className="flex flex-1">
            <img
              className="w-28 sm:w-52 absolute top-6 left-6 sm:top-8 sm:left-16"
              src={Logo}
              alt="Sounds Great"
            />
            <img
              className="w-full h-full object-cover"
              src={BgImage}
              alt="Sounds Great"
            />
          </div>
          <div className="flex flex-1 flex-col gap-12 px-9 lg:px-20 items-center justify-center text-center loginContainer">
            <div className="font-semibold text-[32px] sm:text-[42px]">
              Welcome to ASWAT <br />
              <span className="sm:text-[36px] font-normal text-[#F89A1F]">by Sounds Great</span>
            </div>
            <button
              disabled={loading}
              onClick={(e) => {
                this.setState({ loading: true });

                loginStore.msalLogin().then(() => {
                  this.setState({ loading: false });
                });
              }}
              className="flex w-full bg-[#130D0D] text-white justify-center p-4 rounded-[8px] text-base "
            >
              {!loading && <span>Login</span>}
              <Bars
                height="25"
                width="25"
                color="#F89A1F"
                ariaLabel="bars-loading"
                visible={loading}
              />
            </button>

            {loginStore.loginError && (
              <div className="flex w-full text-red-500 text-base justify-center">
                {loginStore.loginError}
              </div>
            )}
            <div className="flex w-full bg-[#787B7E] border"></div>
            {/* <div className='flex w-full text-[#121619] text-sm justify-center sm:justify-start'>Powered by STX Platform</div> */}
          </div>
        </div>
      );
    }
  }
);

export default withRouter(Login);
